// @flow
import React from 'react'
import type { Node } from 'react'

import EndnoteItem from './endnote-item'

type Content = {
  uuid: number,
  id: string,
  content: Node,
}
type Props = {
  list: Array<Content>,
}

const EndnoteList = ({ list }: Props) => (
  <ol>
    {list.map(item => (
      <EndnoteItem
        key={item.uuid}
        id={item.id}
      >
        {item.content}
      </EndnoteItem>
    ))}
  </ol>
)

export default EndnoteList



// WEBPACK FOOTER //
// ./src/components/typography/endnotes/endnote-list.js